import React from 'react';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {withMeta, Plugins, Atom} from '@packages/systems/wfdl';
import {
  signUpErrorStates,
  ERROR_MSG_CLASS,
  ERROR_ATTRIBUTE_PREFIX,
  SIGNUP_UI_ERROR_CODES,
} from '@packages/systems/users/constants';
import {getErrorAttrName} from '../utils';

import {TTypeConstructor} from '@packages/systems/wfdl-ast';

const UserSignUpErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const updatedClasses = classes.push(ERROR_MSG_CLASS);

    const errorKeys = Object.keys(signUpErrorStates);

    const errorMessagesById = errorKeys.reduce<Record<string, any>>(
      (acc, key) => {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "NOT_ALLOWED" | "NOT_VERIFIED" | "EMAIL_ALREADY_EXIST" | "USE_INVITE_EMAIL" | "INVALID_EMAIL" | "INVALID_PASSWORD" | "EXPIRED_TOKEN" | "VALIDATION_FAILED" | "REQUIRED", ErrorStateType>>'.
        const {id} = signUpErrorStates[key];
        // We now use a more generic data path for multi text state editing but fall back to legacy
        // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
        acc[id] = data?.textStateCopy?.[id] ?? data?.users?.[id];
        return acc;
      },
      {}
    );

    const currentMessage =
      errorMessagesById[
        // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
        data?.temp?.state ?? SIGNUP_UI_ERROR_CODES.GENERAL_ERROR
      ];

    const errorsAttr = errorKeys.reduce<Record<string, any>>(
      (acc, errorKey) => {
        const errorAttrName = getErrorAttrName(
          ERROR_ATTRIBUTE_PREFIX.SIGNUP,
          errorKey
        );
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"GENERAL_ERROR" | "NOT_ALLOWED" | "NOT_VERIFIED" | "EMAIL_ALREADY_EXIST" | "USE_INVITE_EMAIL" | "INVALID_EMAIL" | "INVALID_PASSWORD" | "EXPIRED_TOKEN" | "VALIDATION_FAILED" | "REQUIRED", ErrorStateType>>'.
        acc[errorAttrName] = errorMessagesById[signUpErrorStates[errorKey].id];

        return acc;
      },
      {}
    );

    return (
      <div {...generateAttributes(attributes, updatedClasses)} {...errorsAttr}>
        {currentMessage}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Sign Up Error',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: UserSignUpErrorMsg,
  constraints: {
    pinToParent: true,
    parent: [{is: 'UserFormErrorState', rule: 'ExactlyOne'}],
  },
  hideAncestorSettings: true,
  dataType: withMeta(
    {
      textStates: signUpErrorStates,
      legacyStatePath: ['users'],
    },
    // TODO: this needs to be converted to an Alias https://webflow.atlassian.net/browse/PLAT-639
    TTypeConstructor(
      qualify(Plugins.name('Commerce'), typeName('MultiTextEdit'))
    )
  ),
});

export default config;
